<div class="card bg-white rounded-4 w-100 p-2 shadow p-3">
  <div style="background: linear-gradient(to right, #e1f1db, #e3ebfc)" class="rounded-3 p-3">
    <img src="assets/icons/plan-icon.svg" width="40px" />
    <label class="px-2 fw-semibold">Premium package</label>
  </div>
  <span class="p-2"> No.12343</span>
  <label class="px-2 fw-semibold">Project Name</label>
  <div class="d-flex justify-content-between p-2">
    <span class="text-start">13 APR, 2025</span>
    <span class="text-center px-2"> <img src="assets/icons/linear-icon.svg" /></span>
    <span class="text-end">13 APR, 2026</span>
  </div>
  <div class="py-2">
    <img src="assets/icons/checkmark-circle.svg" width="20px" />
    <label class="px-2">Up to 10 Locations</label>
  </div>
  <div>
    <img src="assets/icons/timer.svg" width="20px" />
    <label class="px-2 text-primary">10 Remaining days</label>
  </div>
</div>
